import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import Reveal from './Reveal';

const CallToAction = ({
  title = 'Have an idea that needs to exist in the real world?',
  text = 'Tell us what you are building. We will help you work out what it takes and the fastest way to a working prototype.',
}) => (
  <section className="container-site py-24">
    <Reveal className="relative overflow-hidden rounded-2xl border border-ink-700 bg-ink-900 px-6 py-14 text-center sm:px-12 md:py-20">
      <div className="grid-bg pointer-events-none absolute inset-0 [mask-image:radial-gradient(ellipse_at_center,black,transparent_70%)]" />
      <div className="pointer-events-none absolute -top-24 left-1/2 h-48 w-2/3 -translate-x-1/2 rounded-full bg-signal-500/20 blur-3xl" />
      <div className="relative">
        <h2 className="mx-auto max-w-2xl font-display text-3xl font-bold text-white md:text-4xl">{title}</h2>
        <p className="mx-auto mt-4 max-w-xl text-slate-400">{text}</p>
        <Link to="/contact" className="btn-primary mt-8">
          Start a conversation <Icon name="arrow" className="h-4 w-4" />
        </Link>
      </div>
    </Reveal>
  </section>
);

export default CallToAction;
